import { FC } from 'react';
import { Capacitor } from '@capacitor/core';
import { Typography } from '@mui/material';
import { CardBannerContent } from 'components/Home/CardBanner/Content';
import { CustomButton } from 'components/shared';
import styles from './index.module.scss';

interface OrderHostCardContentProps {
	onClick: () => void;
}

export const OrderHostCardContent: FC<OrderHostCardContentProps> = ({ onClick }) => {
	return (
		<div className={styles.wrapper}>
			<Typography variant="subtitle1" color="var(--color-primary-500)" marginBottom="var(--spacing-3)">
				Ці сервіси можуть бути сплачені карткою HOSTCARD
			</Typography>
			<CardBannerContent qrCodeClassName={styles.qr} />
			{Capacitor.isNativePlatform() && <CustomButton label="Замовити" onClick={onClick} />}
		</div>
	);
};
